var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fd5900;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.62,42.18c34.95-20.45,70.61,15.45,50.2,50.2,39.07,9.89,39.01,61.38,0,71.24,21.06,34.27-16.14,71.22-50.2,50.2-9.93,39.12-61.42,38.96-71.24,0-34.27,21.06-71.22-16.14-50.2-50.2-39.12-9.93-38.96-61.42,0-71.24-20.45-34.91,15.4-70.63,50.2-50.2,9.93-39.12,61.42-38.96,71.24,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.16,193.18l-28.86-96.56,31.59-9.44,4.93,16.51-14.63,4.37,4.96,16.61,12.61-3.77,4.87,16.3-12.61,3.77,14.09,47.14-16.95,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.53,153.45c.8,2.68,1.14,5.28,1.01,7.79-.13,2.51-.7,4.82-1.72,6.92s-2.47,3.92-4.36,5.46c-1.89,1.54-4.17,2.71-6.87,3.51l-3.73,1.12c-2.69.8-5.28,1.09-7.77.86s-4.77-.93-6.84-2.11c-2.07-1.18-3.89-2.77-5.44-4.78-1.55-2.01-2.73-4.35-3.53-7.04l-23.65-79.12,16.95-5.07,22.85,76.44c.58,1.93,1.18,3.28,1.82,4.06.64.78,1.46,1.02,2.47.72,1.01-.3,1.58-.96,1.72-1.97.14-1.01-.08-2.48-.66-4.41l-22.85-76.44,16.95-5.07,23.65,79.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.87,68.06l24.18,52.22-16.31-54.57,16.95-5.07,28.86,96.56-16.95,5.07-.43-1.44-24.18-52.22,16.74,56.02-16.95,5.07-28.86-96.56,16.95-5.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt1);
export default __webpack_public_path__ + "static/media/art1.d10a816e42596c93cc632d7fc19f3a2d.svg";
export { ForwardRef as ReactComponent };